import { PaymentType } from '@domgen/dgx-fe-common';
import { CheckoutDirectDebitPaymentDetails } from '../../models/checkout-payment/checkout-direct-debit-payment-details.interface';
import { mockCheckoutDirectDebitAccountDetails } from './checkout-direct-debit-account-details.mock';

export const mockCheckoutDirectDebitPaymentDetails: CheckoutDirectDebitPaymentDetails =
  {
    paymentType: PaymentType.DirectDebit,
    directDebitDetails: mockCheckoutDirectDebitAccountDetails,
    preferredPaymentDay: 1,
  };
